import { FunctionComponent, lazy } from "react";
import { App as Component } from "./App";

export const App = lazy<FunctionComponent>(() => {
  return new Promise(resolve => {
    resolve({ default: Component });
  });
});
